import {uniqueId} from 'lodash'
import {CATEGORY_TECHNICAL_SUPPORT} from '@/constants/categoryTechnicalSupport'
import {STATUS_TECHNICAL_SUPPORT_ARRAY} from '@/constants/statusTechnicalSupport'

const columns = [
  {
    title: '',
    prop: 'item',
    type: 'numberRow',
    width: 'minmax(18px, 18px)'
  },
  {
    title: 'Date/Time',
    prop: 'date',
    type: 'date',
    formatDate: 'DD-MMM-YYYY hh:mm:ss a',
    width: 'minmax(100px, 100px)'
  },
  {
    title: 'User name',
    prop: 'user.username',
    capitalize: true,
    filterProp: 'user',
    filterBy: [],
    pointer: true,
    width: 'minmax(100px, max-content)'
  },
  {
    title: 'Category',
    prop: 'category',
    filterProp: 'category',
    filterBy: CATEGORY_TECHNICAL_SUPPORT,
    pointer: true,
    width: 'minmax(100px, 100px)'
  },
  {
    title: 'Comment',
    prop: 'comment',
    type: 'cellHideShow',
    width: 'minmax(200px, 1fr)'
  },
  {
    title: 'File',
    prop: 'uploadFile',
    type: 'fileTable',
    width: 'minmax(55px, 55px)'
  },
  {
    title: 'Status',
    prop: 'status',
    filterProp: 'status',
    filterBy: STATUS_TECHNICAL_SUPPORT_ARRAY,
    options: STATUS_TECHNICAL_SUPPORT_ARRAY,
    isHideSearch: true,
    hideImage: true,
    pointer: true,
    textTransformNone: true,
    label: 'name',
    type: 'selectWithIcon',
    width: 'minmax(120px, 120px)'
  }
]

const prefix = 'technical_support_column_'
const technicalSupportTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default technicalSupportTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/technicalSupportTable.js